module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("角色特权 / " + _vm._s(_vm.roleId ? "编辑" : "新增"))]), _vm._v(" "), _c('el-button', {
    staticClass: "back",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "rules": _vm.formRules,
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "最多20个字符",
      "maxlength": 20
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角色标志",
      "prop": "logo"
    }
  }, [_c('UploadImage', {
    attrs: {
      "keys": "logo",
      "urls": _vm.formData.logo,
      "tips": "80~200 × 80，格式为jpg、png、gif"
    },
    on: {
      "onUrls": _vm.onUrls
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发视频动态权限"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.videoEnabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "videoEnabled", $$v)
      },
      expression: "formData.videoEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "免除广告权限"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.advertisingEnabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "advertisingEnabled", $$v)
      },
      expression: "formData.advertisingEnabled"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "后台创作权限"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.creationEnabled),
      callback: function($$v) {
        _vm.$set(_vm.formData, "creationEnabled", $$v)
      },
      expression: "formData.creationEnabled"
    }
  })], 1), _vm._v(" "), (_vm.roleId) ? _c('el-form-item', {
    attrs: {
      "label": "核心主题"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择核心主题"
    },
    model: {
      value: (_vm.formData.coreTheme),
      callback: function($$v) {
        _vm.$set(_vm.formData, "coreTheme", $$v)
      },
      expression: "formData.coreTheme"
    }
  }, _vm._l((_vm.coreThemeOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "欢迎图"
    }
  }, [_c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=6",
      "keys": "homePicture",
      "urls": _vm.formData.homePicture,
      "tips": "支持jpg、png、gif"
    },
    on: {
      "onUrls": _vm.onUrls
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "续费图",
      "prop": "renewUrl"
    }
  }, [_c('UploadImage', {
    attrs: {
      "keys": "renewUrl",
      "urls": _vm.formData.renewUrl,
      "tips": "支持jpg、png、gif"
    },
    on: {
      "onUrls": _vm.onUrls
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "margin-20"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.handleSave(1)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSave(2)
      }
    }
  }, [_vm._v("保存并上架")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-471bd4d7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PrivilegeRole/PrivilegeRoleDetail.vue
// module id = 1011
// module chunks = 0